import React from 'react';

import {useFeature} from '@optimizely/react-sdk';
import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {getUserProperties} from 'static/three-oh/src/modules/selectors/userSelectors';

import {
  licenseContainer,
  productListContainer,
  productList,
  sectionLabel,
  trialDays,
  listItemStyle,
} from './style.jsx';


const propTypes = {
  licenses: PropTypes.array,
  licensed_collections: PropTypes.array,
  getDaysLeftInTrial: PropTypes.func,
};

const LicenseList = (props) => {
  const [isNewselaLiteEnabled] = useFeature('lite-trial-premium-2023', {autoUpdate: true});
  const licenseByStatus = {
    is_subscription: [],
    is_trial: [],
    free: [],
  };
  const licenseNameMap = {
    ela: 'Newsela ELA',
    science: 'Newsela Science',
    social_studies: 'Newsela Social Studies',
    essentials: 'Newsela Essentials',
    power_words: 'Power Words',
    teacher_learning_hub: 'PD Pass',
    collections: 'Collections'
  };
    // TODO: potentially use subscriptionProducts for district admins to dedupe between trial and subscription links
    // or show district admins something totally different as this feature might not make sense for them.
  const licenses = props.licenses ? props.licenses : useSelector((state) => state?.user?.licenses);
  const activeLicenses = licenses.filter((license) => license.is_active);

  if (isNewselaLiteEnabled) {
    const uniqueLicenses = activeLicenses.reduce((object, value) => ({...object, [value.product]: value}), {});
    return (
      <div className={productListContainer}>
        <div className={productList}>
          <div className={licenseContainer}>
            <h2 className={sectionLabel}>Subscription Products</h2>
          </div>
          <ul>
            {Object.values(uniqueLicenses).map((license) => (
              <li key={license.product} className={listItemStyle}>{licenseNameMap[license.product]}</li>
            ))}
            {isEmpty(uniqueLicenses) && <li className={listItemStyle}>Newsela Lite</li>}
          </ul>
        </div>
      </div>
    );
  }

  if (isEmpty(activeLicenses)) return null;

  licenses.map((license) => {
    // Exclude free products from this display.
    // Check that the license is active.
    if (license.is_active) {
      if (license.is_subscription) {
        licenseByStatus.is_subscription.push(license);
      }
      if (license.is_trial) {
        licenseByStatus.is_trial.push(license);
      }
    }
  });


  // dedupe trials and subscriptions
  const isSubscriptionUnique = [...new Set(licenseByStatus.is_subscription.map((item) => item.product))];
  const isTrialUnique = [...new Set(licenseByStatus.is_trial.map((item) => item.product))];

  // TODO: eventually we will be trialing collections
  const daysLeftInTrial = props.getDaysLeftInTrial ? props.getDaysLeftInTrial(licenseByStatus.is_trial[0])
    : useSelector((state) => getUserProperties(state).getDaysLeftInTrial(licenseByStatus.is_trial[0]));
  return (
    <div className={productListContainer}>
      {
          licenseByStatus.is_trial.length ?
            <div className={productList}>
              <div className={licenseContainer}>
                <h2 className={sectionLabel}>
                  Trial Product{licenseByStatus.is_trial.length > 1 ? 's' : ''}
                </h2>
                {
                  daysLeftInTrial && daysLeftInTrial < 90 ?
                    <div className={trialDays}>{daysLeftInTrial} days left</div> :
                    null
                }
              </div>
              <ul>
                {
                  isTrialUnique.map((license) => {
                    return (<li key={license}>{licenseNameMap[license]}</li>);
                  })
                }
              </ul>
            </div> :
            null
        }
      {
          licenseByStatus.is_subscription.length ?
            <div className={productList}>
              <div className={licenseContainer}>
                <h2 className={sectionLabel}>
                  Subscription Product{licenseByStatus.is_subscription.length > 1 ? 's' : ''}
                </h2>
              </div>
              <ul>
                {
                  isSubscriptionUnique.map((license) => {
                    return (<li key={license}>{licenseNameMap[license]}</li>);
                  })
                }
              </ul>
            </div> :
            null
        }
    </div>
  );
};

LicenseList.propTypes = propTypes;
export default LicenseList;
